import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Actions, Action } from "../../ai-elements/actions.js";
import { Shimmer } from "../../ai-elements/shimmer.js";
import brandclub_colors from "../../colors/brandclubColors.js";
import { CopyIcon } from "../../icons/CopyIcon.js";
import { ShareIcon } from "../../icons/ShareIcon.js";
import { ThumbsDownIcon } from "../../icons/ThumbsDownIcon.js";
import { ThumbsUpIcon } from "../../icons/ThumbsUpIcon.js";
import React__default, { useState, useMemo, useRef, useLayoutEffect } from "react";
import { toast } from "sonner";
import { getHeadersWithUniqueVisitorId } from "../../Auth/index.js";
import { setConversationSharing, sendMessageFeedback } from "../api.js";
import { marked } from "marked";
import { ConciergeMessagePart } from "./ConciergeMessagePart/index.js";
import { ConfirmActionDialog } from "./ConfirmActionDialog.js";
import { ShareConversationDialog } from "./ShareConversationDialog.js";
import DevInfoPanel from "./DevInfoPanel.js";
import { StoreLocatorWidget } from "./StoreLocatorWidget/index.js";
import { OrderCardList } from "./OrderCard.js";
import { ChainOfThoughtWidget, MessageBubbleWidget, themeColor, customColor, FollowUpQueriesWidget } from "@brandclub/bc-widgets";
const RetryIcon = () => /* @__PURE__ */ jsx("svg", { width: "16", height: "16", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
  "path",
  {
    d: "M6.42773 0.712891C8.44953 -0.0644025 10.6705 -0.161105 12.752 0.438477C14.8331 1.03803 16.6616 2.30075 17.96 4.03418L18.0508 4.1543V1.99707C18.0508 1.74523 18.1501 1.5033 18.3281 1.3252C18.5062 1.14712 18.7482 1.04693 19 1.04688C19.2519 1.04688 19.4938 1.14712 19.6719 1.3252C19.85 1.50332 19.9502 1.74517 19.9502 1.99707V6.99609C19.9502 7.24796 19.85 7.48987 19.6719 7.66797C19.4938 7.846 19.2518 7.94531 19 7.94531H14.001C13.7494 7.94525 13.5081 7.84577 13.3301 7.66797C13.152 7.48987 13.0518 7.24796 13.0518 6.99609C13.0518 6.74419 13.152 6.50234 13.3301 6.32422C13.5081 6.14635 13.7493 6.04596 14.001 6.0459H16.9971L16.9541 5.9707C16.0546 4.42358 14.6635 3.22089 13.0029 2.55371C11.3425 1.88671 9.50681 1.79343 7.78711 2.28809C6.06718 2.78287 4.56106 3.8375 3.50879 5.28516C2.45654 6.7328 1.91838 8.49064 1.97852 10.2793C2.03867 12.0679 2.69373 13.7855 3.84082 15.1592C4.98794 16.5329 6.56127 17.4842 8.31055 17.8623C10.0598 18.2404 11.885 18.0233 13.4971 17.2461C15.109 16.4689 16.4154 15.1762 17.209 13.5723L17.21 13.5713C17.2649 13.4588 17.3416 13.3582 17.4355 13.2754C17.5294 13.1927 17.6385 13.1292 17.7568 13.0889C17.8753 13.0486 18.0011 13.0318 18.126 13.04C18.251 13.0484 18.3741 13.0819 18.4863 13.1377C18.5983 13.1934 18.6982 13.2708 18.7803 13.3652C18.8624 13.4598 18.9254 13.5696 18.9648 13.6885C19.0043 13.8074 19.02 13.9336 19.0107 14.0586C19.0038 14.1521 18.9829 14.2439 18.9492 14.3311L18.9102 14.417C17.9479 16.3576 16.3785 17.9311 14.4404 18.8984C12.5025 19.8657 10.302 20.1747 8.17285 19.7773C6.04356 19.3799 4.10211 18.2977 2.64355 16.6963C1.18503 15.0949 0.289168 13.0613 0.0917969 10.9043C-0.105553 8.74727 0.406113 6.5846 1.5498 4.74512C2.69343 2.90583 4.4062 1.4902 6.42773 0.712891Z",
    fill: "currentColor",
    stroke: "currentColor",
    "stroke-width": "0.1"
  }
) });
const ChatMessageComponent = React__default.forwardRef(
  ({
    role,
    content,
    bottomRef,
    isTyping = false,
    isStreaming = false,
    isLastMessage = false,
    messageIndex,
    conversationId,
    feedback,
    followUpQueries = [],
    nextUserMessage,
    storeLocator,
    streamingStoreLocator,
    orders,
    devInfo,
    onSignIn,
    onSearch,
    onUpdateFeedback,
    onVariantSelect,
    onSuggestionClick,
    apiBaseUrl,
    isSharedView,
    uiMessageParts,
    transientStatus,
    pdpStacklineSku,
    isOnChatWidget,
    brandLogoUrl,
    onRetry
  }, _ref) => {
    var _a;
    const isUser = role === "user";
    const hasUiMessageParts = Array.isArray(uiMessageParts) && uiMessageParts.length > 0;
    const hasAnyContent = content.length > 0 || hasUiMessageParts && uiMessageParts.some((p) => p.type !== "text" || p.text);
    const showCursor = isStreaming && !isTyping && hasAnyContent;
    const [liked, setLiked] = useState((feedback == null ? void 0 : feedback.type) === "like");
    const [disliked, setDisliked] = useState((feedback == null ? void 0 : feedback.type) === "dislike");
    const [retryConfirmOpen, setRetryConfirmOpen] = useState(false);
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const [localSelectedFollowUp, setLocalSelectedFollowUp] = useState(void 0);
    const derivedSelectedFollowUp = useMemo(() => {
      if (!nextUserMessage || !followUpQueries.length) return void 0;
      return followUpQueries.find((query) => query === nextUserMessage);
    }, [nextUserMessage, followUpQueries]);
    const selectedFollowUp = derivedSelectedFollowUp || localSelectedFollowUp;
    const userMessageRef = useRef(null);
    const [isMultiline, setIsMultiline] = useState(false);
    const assistantContentRef = useRef(null);
    const [assistantBubbleWidth, setAssistantBubbleWidth] = useState(void 0);
    const hasWidgetParts = useMemo(
      () => Array.isArray(uiMessageParts) && uiMessageParts.some((p) => !["text", "source-url", "data-follow-ups"].includes(p.type)),
      [uiMessageParts]
    );
    useLayoutEffect(() => {
      if (!isUser || !userMessageRef.current) return;
      const el = userMessageRef.current;
      const textNode = el.firstChild;
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const rects = range.getClientRects();
        setIsMultiline(rects.length > 1);
      } else {
        const computedStyle = window.getComputedStyle(el);
        const lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.5;
        setIsMultiline(el.scrollHeight > lineHeight * 1.5);
      }
    }, [isUser, content]);
    useLayoutEffect(() => {
      if (isUser || isTyping || hasWidgetParts) {
        setAssistantBubbleWidth(void 0);
        return;
      }
      const el = assistantContentRef.current;
      if (!el) {
        setAssistantBubbleWidth(void 0);
        return;
      }
      const containerLeft = el.getBoundingClientRect().left;
      const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      let maxRight = 0;
      let node;
      while (node = walker.nextNode()) {
        const range = document.createRange();
        range.selectNodeContents(node);
        const rects = range.getClientRects();
        for (let i = 0; i < rects.length; i++) {
          maxRight = Math.max(maxRight, rects[i].right);
        }
      }
      if (maxRight > 0) {
        const textWidth = maxRight - containerLeft;
        const computedStyle = window.getComputedStyle(el);
        const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
        const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
        const neededWidth = Math.ceil(textWidth) + paddingLeft + paddingRight + 2;
        if (neededWidth < el.offsetWidth - 8) {
          setAssistantBubbleWidth(neededWidth);
        } else {
          setAssistantBubbleWidth(void 0);
        }
      } else {
        setAssistantBubbleWidth(void 0);
      }
    }, [isUser, isTyping, content, hasUiMessageParts, hasWidgetParts]);
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(content);
        toast.success("Message copied to clipboard");
      } catch (error) {
        toast.error("Failed to copy message");
      }
    };
    const handleShare = () => {
      if (!conversationId) {
        console.warn("Cannot share: missing conversationId");
        return;
      }
      setShareDialogOpen(true);
    };
    const handleShareCopyLink = async () => {
      if (!conversationId) throw new Error("Missing conversationId");
      const headers = await getHeadersWithUniqueVisitorId();
      const result = await setConversationSharing({
        conversationId,
        enabled: true,
        messageIndex,
        headersToInject: headers,
        apiBaseUrl
      });
      return result.shareUrl;
    };
    const handleLike = async () => {
      var _a2;
      if (!conversationId || messageIndex === void 0) {
        toast.error("Cannot like: conversation not loaded");
        return;
      }
      try {
        const newState = !liked;
        const headers = await getHeadersWithUniqueVisitorId();
        const result = await sendMessageFeedback({
          conversationId,
          messageIndex,
          feedbackType: newState ? "like" : null,
          headersToInject: headers,
          apiBaseUrl
        });
        setLiked(newState);
        setDisliked(false);
        toast.success(newState ? "Message liked" : "Like removed");
        if (onUpdateFeedback && ((_a2 = result.message.metadata) == null ? void 0 : _a2.feedback)) {
          onUpdateFeedback(messageIndex, result.message.metadata.feedback);
        }
      } catch (error) {
        console.error("Failed to update feedback:", error);
        toast.error("Failed to save feedback");
      }
    };
    const handleDislike = async () => {
      var _a2;
      if (!conversationId || messageIndex === void 0) {
        toast.error("Cannot dislike: conversation not loaded");
        return;
      }
      try {
        const newState = !disliked;
        const headers = await getHeadersWithUniqueVisitorId();
        const result = await sendMessageFeedback({
          conversationId,
          messageIndex,
          feedbackType: newState ? "dislike" : null,
          headersToInject: headers,
          apiBaseUrl
        });
        setDisliked(newState);
        setLiked(false);
        toast.success(newState ? "Message disliked" : "Dislike removed");
        if (onUpdateFeedback && ((_a2 = result.message.metadata) == null ? void 0 : _a2.feedback)) {
          onUpdateFeedback(messageIndex, result.message.metadata.feedback);
        }
      } catch (error) {
        console.error("Failed to update feedback:", error);
        toast.error("Failed to save feedback");
      }
    };
    const handleFollowUpClick = (query) => {
      if (!isLastMessage || selectedFollowUp) return;
      setLocalSelectedFollowUp(query);
      onSearch == null ? void 0 : onSearch(query);
    };
    const getJustifyContent = (alignment) => {
      switch (alignment) {
        case "right":
          return "flex-end";
        case "center":
          return "center";
        default:
          return "flex-start";
      }
    };
    const renderUserMessageBubble = () => /* @__PURE__ */ jsx(
      MessageBubbleWidget,
      {
        widgetId: "concierge-user-message",
        displayName: "User Message Bubble",
        initialState: {
          bgColor: customColor(brandclub_colors.blueWhite),
          textColor: themeColor("textPrimary"),
          maxWidth: "90%",
          alignment: "right"
        },
        children: (styles, resolveColor) => {
          const borderRadius = isMultiline ? styles.borderRadius : styles.borderRadiusShort;
          const fontFamily = styles.fontFamilyCss ? styles.fontFamilyCss !== "inherit" ? styles.fontFamilyCss : "var(--concierge-user-message-font-family, inherit)" : "var(--concierge-user-message-font-family, inherit)";
          return /* @__PURE__ */ jsx(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                alignItems: getJustifyContent(styles.alignment),
                width: "100%"
              },
              children: /* @__PURE__ */ jsx("div", { style: { maxWidth: styles.maxWidth }, children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: "message-content user-message",
                  style: {
                    maxWidth: "100%",
                    minWidth: "50px",
                    backgroundColor: resolveColor(styles.bgColor),
                    color: resolveColor(styles.textColor),
                    borderRadius: `${borderRadius}px`,
                    wordWrap: "break-word",
                    padding: `${styles.paddingY}px ${styles.paddingX}px`,
                    fontSize: `${styles.fontSize}px`,
                    fontWeight: styles.fontWeight,
                    fontFamily,
                    lineHeight: styles.lineHeight,
                    ...!isMultiline && styles.singleLineHeight > 0 ? {
                      minHeight: styles.singleLineHeight,
                      display: "flex",
                      alignItems: "center",
                      boxSizing: "border-box"
                    } : {}
                  },
                  children: /* @__PURE__ */ jsx("div", { ref: userMessageRef, style: { whiteSpace: "pre-wrap" }, children: content })
                }
              ) })
            }
          );
        }
      }
    );
    const renderAssistantMessageBubble = () => /* @__PURE__ */ jsx(
      MessageBubbleWidget,
      {
        widgetId: "concierge-assistant-message",
        displayName: "Assistant Message Bubble",
        initialState: {
          bgColor: themeColor("secondary"),
          textColor: themeColor("textPrimary"),
          maxWidth: "100%",
          paddingX: 0,
          paddingY: 0,
          alignment: "left"
        },
        children: (styles, resolveColor) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: getJustifyContent(styles.alignment),
              width: "100%"
            },
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                style: { maxWidth: styles.maxWidth, width: hasWidgetParts ? "100%" : assistantBubbleWidth ?? void 0 },
                children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      ref: assistantContentRef,
                      className: "message-content",
                      style: {
                        maxWidth: "100%",
                        minWidth: "50px",
                        backgroundColor: resolveColor(styles.bgColor),
                        color: resolveColor(styles.textColor),
                        borderRadius: `${styles.borderRadius}px`,
                        wordWrap: "break-word",
                        padding: `${styles.paddingY}px ${styles.paddingX}px`,
                        fontSize: `${styles.fontSize}px`,
                        fontWeight: styles.fontWeight,
                        lineHeight: styles.lineHeight
                      },
                      children: [
                        hasUiMessageParts ? /* @__PURE__ */ jsx(
                          ConciergeMessagePart,
                          {
                            parts: uiMessageParts,
                            onProductClick: onVariantSelect,
                            isStreaming,
                            pdpStacklineSku,
                            isOnChatWidget,
                            apiBaseUrl,
                            onSignIn
                          }
                        ) : /* @__PURE__ */ jsx(
                          "div",
                          {
                            className: "message-markdown",
                            style: { display: "flex", flexDirection: "column" },
                            dangerouslySetInnerHTML: { __html: marked.parse(content) }
                          }
                        ),
                        showCursor && /* @__PURE__ */ jsxs(Fragment, { children: [
                          /* @__PURE__ */ jsx("style", { children: `@keyframes cc-blink{0%,50%{opacity:1}51%,100%{opacity:0}}` }),
                          /* @__PURE__ */ jsx(
                            "span",
                            {
                              style: {
                                display: "inline-block",
                                width: "2px",
                                height: "16px",
                                backgroundColor: "#000",
                                borderRadius: "1px",
                                marginLeft: "3px",
                                marginTop: "4px",
                                verticalAlign: "text-bottom",
                                animation: "cc-blink 0.8s step-end infinite"
                              }
                            }
                          )
                        ] }),
                        orders && orders.length > 0 && /* @__PURE__ */ jsx(OrderCardList, { orders })
                      ]
                    }
                  ),
                  bottomRef && /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        height: "1px",
                        width: "100%"
                      },
                      ref: bottomRef
                    }
                  ),
                  !isTyping && !isStreaming && content.length > 0 ? /* @__PURE__ */ jsxs(Actions, { className: "tw:mt-2", children: [
                    /* @__PURE__ */ jsx(Action, { label: "Copy", tooltip: "Copy", onClick: handleCopy, children: /* @__PURE__ */ jsx(CopyIcon, {}) }),
                    /* @__PURE__ */ jsx(Action, { label: "Like", tooltip: "Like", onClick: handleLike, children: /* @__PURE__ */ jsx(ThumbsUpIcon, { className: liked ? "tw:fill-current tw:text-primary" : "" }) }),
                    /* @__PURE__ */ jsx(Action, { label: "Dislike", tooltip: "Dislike", onClick: handleDislike, children: /* @__PURE__ */ jsx(ThumbsDownIcon, { className: disliked ? "tw:fill-current tw:text-primary" : "" }) }),
                    !isSharedView && /* @__PURE__ */ jsx(Action, { label: "Share", tooltip: "Share", onClick: handleShare, children: /* @__PURE__ */ jsx(ShareIcon, {}) }),
                    isLastMessage && !isSharedView && onRetry && /* @__PURE__ */ jsx(Action, { label: "Retry", tooltip: "Retry response", onClick: () => setRetryConfirmOpen(true), children: /* @__PURE__ */ jsx(RetryIcon, {}) })
                  ] }) : null,
                  !isTyping && !isStreaming && followUpQueries.length > 0 && !(nextUserMessage && !selectedFollowUp) && /* @__PURE__ */ jsx(FollowUpQueriesWidget, { widgetId: "concierge-follow-up-queries", displayName: "Follow-up Suggestions", children: (widgetStyles, resolveColor2) => {
                    const isDisabled = !isLastMessage || !!selectedFollowUp;
                    return /* @__PURE__ */ jsx(
                      "div",
                      {
                        style: {
                          display: "flex",
                          flexWrap: "wrap",
                          marginTop: 32,
                          gap: `${widgetStyles.containerGap}px`,
                          width: "100%"
                        },
                        children: followUpQueries.map((query, index) => {
                          const isSelected = selectedFollowUp === query;
                          let bgColor = resolveColor2(widgetStyles.pillBgColor);
                          let textColor = resolveColor2(widgetStyles.pillTextColor);
                          let borderColor = resolveColor2(widgetStyles.pillBorderColor);
                          let cursor = "pointer";
                          let opacity = 1;
                          if (isSelected) {
                            bgColor = resolveColor2(widgetStyles.pillBgColorSelected);
                            textColor = resolveColor2(widgetStyles.pillTextColorSelected);
                            borderColor = resolveColor2(widgetStyles.pillBorderColorSelected);
                            cursor = "default";
                          } else if (isDisabled) {
                            opacity = 0.5;
                            cursor = "not-allowed";
                          }
                          return /* @__PURE__ */ jsx(
                            "button",
                            {
                              onClick: () => handleFollowUpClick(query),
                              disabled: isDisabled && !isSelected,
                              style: {
                                padding: `${widgetStyles.pillPaddingY}px ${widgetStyles.pillPaddingX}px`,
                                borderRadius: `${widgetStyles.pillBorderRadius}px`,
                                border: `${widgetStyles.pillBorderWidth}px solid ${borderColor}`,
                                backgroundColor: bgColor,
                                color: textColor,
                                fontSize: `${widgetStyles.pillFontSize}px`,
                                fontWeight: widgetStyles.pillFontWeight,
                                cursor,
                                opacity,
                                transition: "all 0.2s ease",
                                lineHeight: "22px",
                                maxWidth: "100%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap"
                              },
                              onMouseEnter: (e) => {
                                if (!isDisabled && !isSelected) {
                                  e.currentTarget.style.backgroundColor = resolveColor2(widgetStyles.pillBgColorHover);
                                }
                              },
                              onMouseLeave: (e) => {
                                if (!isDisabled && !isSelected) {
                                  e.currentTarget.style.backgroundColor = resolveColor2(widgetStyles.pillBgColor);
                                }
                              },
                              title: query,
                              children: query
                            },
                            index
                          );
                        })
                      }
                    );
                  } })
                ]
              }
            )
          }
        )
      }
    );
    if (isStreaming && !isTyping && !hasAnyContent) return null;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: `message ${role}`,
        style: {
          display: "flex",
          flexDirection: "column",
          width: "100%"
        },
        children: [
          !isUser && devInfo && /* @__PURE__ */ jsx(DevInfoPanel, { devInfo }),
          !isUser && (storeLocator || streamingStoreLocator) && /* @__PURE__ */ jsx(
            StoreLocatorWidget,
            {
              stacklineSku: ((_a = storeLocator || streamingStoreLocator) == null ? void 0 : _a.stacklineSku) || "",
              apiUrl: apiBaseUrl
            }
          ),
          !isUser && isTyping && /* @__PURE__ */ jsx(ChainOfThoughtWidget, { widgetId: "chain-of-thought", displayName: "Chain of Thought", children: (styles, resolveColor) => styles.thinkingEnabled ? /* @__PURE__ */ jsx("div", { style: { maxWidth: "100%" }, children: /* @__PURE__ */ jsx(
            "div",
            {
              className: "message-content",
              style: {
                maxWidth: "100%",
                backgroundColor: "none",
                color: resolveColor(styles.thinkingTextColor),
                borderRadius: `${styles.thinkingBorderRadius}px`,
                borderBottomLeftRadius: `${styles.thinkingBorderRadiusBottomLeft}px`,
                borderBottomRightRadius: `${styles.thinkingBorderRadius}px`,
                wordWrap: "break-word",
                padding: `${styles.thinkingPaddingY}px ${styles.thinkingPaddingX}px`
              },
              children: /* @__PURE__ */ jsx(
                Shimmer,
                {
                  as: "p",
                  style: { fontSize: `${styles.thinkingTextFontSize}px` },
                  duration: styles.shimmerDuration,
                  color: resolveColor(styles.thinkingTextColor),
                  highlightColor: resolveColor(styles.shimmerColor),
                  children: styles.thinkingText
                }
              )
            }
          ) }) : null }),
          isUser && hasUiMessageParts && (() => {
            const imageFiles = uiMessageParts.filter(
              (p) => {
                var _a2;
                return p.type === "file" && ((_a2 = p.mediaType) == null ? void 0 : _a2.startsWith("image/"));
              }
            );
            if (imageFiles.length === 0) return null;
            return /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  display: "flex",
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: "0.5rem",
                  width: "100%",
                  marginBottom: "0.5rem"
                },
                children: imageFiles.map((fp, i) => /* @__PURE__ */ jsx(
                  "img",
                  {
                    src: fp.url,
                    alt: fp.filename || "Uploaded image",
                    style: {
                      maxWidth: imageFiles.length === 1 ? "70%" : "45%",
                      maxHeight: "300px",
                      objectFit: "cover",
                      display: "block",
                      borderRadius: "12px"
                    }
                  },
                  i
                ))
              }
            );
          })(),
          !isTyping && (isUser ? renderUserMessageBubble() : renderAssistantMessageBubble()),
          /* @__PURE__ */ jsx(
            ConfirmActionDialog,
            {
              open: retryConfirmOpen,
              title: "Retry response?",
              message: "The latest user and assistant messages will be removed.",
              confirmText: "Retry",
              onCancel: () => setRetryConfirmOpen(false),
              onConfirm: () => {
                setRetryConfirmOpen(false);
                onRetry == null ? void 0 : onRetry();
              }
            }
          ),
          /* @__PURE__ */ jsx(
            ShareConversationDialog,
            {
              open: shareDialogOpen,
              onClose: () => setShareDialogOpen(false),
              onCopyLink: handleShareCopyLink,
              brandLogoUrl
            }
          )
        ]
      }
    );
  }
);
function uiPartsFingerprint(parts) {
  if (!(parts == null ? void 0 : parts.length)) return "";
  return `${parts.length}:${parts.map((p) => {
    var _a, _b;
    if (p.type === "text") return `text|${((_a = p.text) == null ? void 0 : _a.length) ?? 0}`;
    if (p.type === "data-section") return `ds|${((_b = p.data) == null ? void 0 : _b.title) ?? ""}`;
    return `${p.type}|${p.state ?? ""}`;
  }).join(",")}`;
}
const ChatMessage = React__default.memo(ChatMessageComponent, (prevProps, nextProps) => {
  var _a, _b;
  return prevProps.role === nextProps.role && prevProps.content === nextProps.content && prevProps.isTyping === nextProps.isTyping && prevProps.bottomRef === nextProps.bottomRef && prevProps.isStreaming === nextProps.isStreaming && prevProps.isLastMessage === nextProps.isLastMessage && ((_a = prevProps.followUpQueries) == null ? void 0 : _a.length) === ((_b = nextProps.followUpQueries) == null ? void 0 : _b.length) && prevProps.nextUserMessage === nextProps.nextUserMessage && prevProps.storeLocator === nextProps.storeLocator && prevProps.streamingStoreLocator === nextProps.streamingStoreLocator && prevProps.orders === nextProps.orders && prevProps.onSignIn === nextProps.onSignIn && prevProps.onSearch === nextProps.onSearch && prevProps.onVariantSelect === nextProps.onVariantSelect && prevProps.onSuggestionClick === nextProps.onSuggestionClick && uiPartsFingerprint(prevProps.uiMessageParts) === uiPartsFingerprint(nextProps.uiMessageParts);
});
export {
  ChatMessage
};
//# sourceMappingURL=ChatMessage.js.map
